/**
 * @owner @Appboy/core-objects
 */
export const customObjectsTypeNameObjectId = "/data_objects/:type_name/:object_id" as const;

/** Keep in sync with customObjectsTypeName — literal avoids circular import with that module. */
export const customObjectsTypeNameObjectIdCacheKeys = ["/data_objects/:type_name"] as const;
